// RawTableOverview now lives under the Brands module folder — moved, not duplicated.
import RawTableOverview from "../../../../components/Partners/DataIntegrations/Brands/BrandConfigurationOverview/RawTableOverview/RawTableOverview"

const RawTableOverviewScreen = () => {
  return (
    <>
    <RawTableOverview />
    </>
  )
}

export default RawTableOverviewScreen